import { type CarConfigDispatchType, useCarConfigSelector } from "../redux/store";
import { MODAL_ORDER_CHECKOUT } from "../utils/modalConstants";
import { showModal } from "../../../../common-deprecated/redux/actions/ModalActions";
import { isCheckoutModalActive } from "../utils/checkoutModalUtils";
import { useDispatch } from "../../../../shared-logic/redux/store";

type CheckoutModalState = {
    enabled: boolean;
    active: boolean;
    open?: () => void;
};

const useAphCheckoutModal = (): {
    buy: CheckoutModalState;
    reserve: CheckoutModalState;
    lease: CheckoutModalState;
} => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const checkoutConfigs = useCarConfigSelector((state) => state.carConfigSettings.checkoutModalConfigs);
    const openModals = useCarConfigSelector((state) => state.modal.modals);

    return {
        buy: {
            enabled: !!checkoutConfigs?.buy,
            active: isCheckoutModalActive(openModals, "buy"),
            open: () => dispatch(showModal({ type: MODAL_ORDER_CHECKOUT, checkoutType: "buy" })),
        },
        reserve: {
            enabled: !!checkoutConfigs?.reserve,
            active: isCheckoutModalActive(openModals, "reserve"),
            open: () => dispatch(showModal({ type: MODAL_ORDER_CHECKOUT, checkoutType: "reserve" })),
        },
        lease: {
            enabled: !!checkoutConfigs?.lease,
            active: isCheckoutModalActive(openModals, "lease"),
            open: () => dispatch(showModal({ type: MODAL_ORDER_CHECKOUT, checkoutType: "lease" })),
        },
    };
};

export default useAphCheckoutModal;
